"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = exports.TextareaVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const get_1 = __importDefault(require("lodash/get"));
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const Utils_1 = require("../../utils/Utils");
const Label_1 = require("../Label/Label");
const Textarea_styles_1 = require("./styles/Textarea.styles");
const __DEV__ = process.env.NODE_ENV !== 'production';
var TextareaVariants;
(function (TextareaVariants) {
    TextareaVariants["DEFAULT"] = "default";
})(TextareaVariants = exports.TextareaVariants || (exports.TextareaVariants = {}));
const Textarea = (props) => {
    var _a;
    const { allowResize = false, ariaLabel, autoComplete = 'off', autoCorrect = 'off', className = '', cols, disabled = false, hasError = false, helperMessage, id, label, localClassName = 'Textarea-local', maxLength, minLength, name, onBlur, onChange, onFocus, onKeyPress, placeholder = '', readOnly = false, rows = 5, shouldHideLabel = false, spellCheck = 'false', testId, value, variant = TextareaVariants.DEFAULT, wrap = 'off', } = props;
    const [hasFocus, setHasFocus] = (0, react_1.useState)(false);
    const [textareaId] = (0, react_1.useState)(id !== null && id !== void 0 ? id : (0, Utils_1.generateUUID)());
    const theme = (0, ThemeProvider_1.useTheme)();
    if (!theme) {
        if (__DEV__) {
            console.error('`Textarea` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    let textareaStyles = theme.variants.textareas.default;
    const textareaVariantStyles = (0, get_1.default)((_a = theme === null || theme === void 0 ? void 0 : theme.variants) === null || _a === void 0 ? void 0 : _a.textareas, variant);
    if (!textareaVariantStyles) {
        if (__DEV__) {
            console.error(`Could not find TextAreas variant 'textareas.${variant}'. Falling back to default textarea styles.`);
        }
        textareaStyles = theme.variants.textareas.default;
    }
    else {
        textareaStyles = Object.assign(Object.assign({}, textareaStyles), textareaVariantStyles);
    }
    const textareaWidth = allowResize ? 'fit-content' : '100%';
    textareaStyles.width = textareaWidth;
    textareaStyles.minWidth = textareaWidth;
    const styles = (0, Textarea_styles_1.getTextareaStyles)({ styles: textareaStyles, theme, shouldHideLabel });
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    const helperContent = (el) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `${styles.helperContainer} ${hasError ? styles.errorMessage : ''}` }, { children: el })));
    const handleOnFocus = (e) => {
        setHasFocus(true);
        if (onFocus)
            onFocus(e);
    };
    const handleOnBlur = (e) => {
        setHasFocus(false);
        if (onBlur)
            onBlur(e);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `Textarea-container-local ${styles.container}` }, dti, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${localClassName} ${styles.wrapper} ${hasError ? styles.hasError : ''} ${disabled ? styles.disabled : ''} ${hasFocus ? styles.focus : ''} ${className}` }, { children: [(0, jsx_runtime_1.jsx)(Label_1.Label, { htmlFor: textareaId, content: !shouldHideLabel ? label : undefined, screenReaderOnlyText: shouldHideLabel ? label : undefined, className: `${styles.label} ${disabled ? styles.disabled : ''} ${hasError ? styles.hasError : ''}` }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: styles.innerWrapper }, { children: (0, jsx_runtime_1.jsx)("textarea", { "aria-label": ariaLabel, id: textareaId, name: name, disabled: disabled, minLength: minLength, maxLength: maxLength, className: `${styles.textarea} ${!allowResize ? styles.preventResize : ''}`, value: value, spellCheck: spellCheck, autoComplete: autoComplete, autoCorrect: autoCorrect, wrap: wrap, rows: rows, cols: cols, readOnly: readOnly, placeholder: placeholder, onFocus: handleOnFocus, onBlur: handleOnBlur, onChange: onChange, onKeyPress: onKeyPress }) }))] })), helperMessage && helperContent(helperMessage)] })));
};
exports.Textarea = Textarea;
